<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    @checkTable="selectItems"
    ref="table"
  >
    <template #header>
      <Tabs type="card" v-model="tabName" @on-click="handleTab">
        <TabPane
          v-for="(item, idx) in tabList"
          :key="idx"
          :label="item"
          :name="item"
        />
      </Tabs>
    </template>
  </cTable>
</template>

<script>
import {
  getList,
  add,
  del,
  Del,
  batchDel,
  update,
  batchEditTime,
  saveWeight,
  getDetails,
  exportFun1,
  uploadFile,
  b2bWarehouse,
  exportFun,
  addFile,
  addFiles,
  getService,
  excel,
  src,
  upload,
  matchOrder, signProof,
} from "@/api/forecastManagement/deliveryService";
import { getAddress } from "@/api/double/list";
import cTable from "@/base/common/index";
import { getCompanies } from "@/api/user/client";
import Sku from "./sku.vue";
import { getSelectType, upload as CommonUpload } from "@/api/public";
import { getAllClient } from "@/api/user/client";
import { getAllService } from "@/api/user/internal";
import { getCountry } from "@/api/system/country";
import { getUser } from "@/api/double/list";
import getLodop from "@/utils/lodop";
export default {
  name: "deliveryService",
  components: {
    cTable,
  },
  methods: {
    selectItems(val) {
      this.selectItem[this.tabName] = val.map(v => v.b2b_no)
    },
    handleTab() {
      if (this.searchs[this.tabName]) {
        this.$refs["table"].$refs["header"].searchForm =
          this.searchs[this.tabName];
      } else {
        this.$refs["table"].$refs["header"].searchForm = {};
      }
      this.$refs["table"].pageConfig.page = 1;
      this.$refs["table"].pageConfig.size = 15;
      this.config.tabName = this.tabName;
      this.$refs["table"].resize();
      this.$refs["table"].getList();
      this.$refs["table"].getTable().recalculate(true);
    },
  },
  data() {
    let deliveryOptions = [
      { label: "FBA", value: "FBA" },
      { label: "FBN", value: "FBN" },
      { label: "FBT", value: "FBT" },
      { label: "FBJ", value: "FBJ" },
    ];
    return {
      selectItem: {},
      searchs: {},
      tabList: ["FBA", "FBN", "FBT", "FBJ"],
      tabName: "FBA",
      warehouse: [],
      methods: {
        list: (p) => {
          p.label = this.tabName;
          this.searchs[this.tabName] = p;
          this.searchs[this.tabName]['selectItems'] = this.selectItem[this.tabName]
          return getList(p);
        },
        getDetails,
        del,
        add,
        update,
        getCompanies,
        b2bWarehouse,
        exportFun,
        exportFun1,
        addFile,
        addFiles,
        getService,
        excel,
        src,
        upload,
        Del,
        getAllClient,
        matchOrder,
        batchDel,
        CommonUpload,
        batchEditTime,
        saveWeight,
      },
      footer: {},
      config: {
        children: true,
        showOverflow: false,
        // mergeRows: ["appointment_no"],
        mergeRows: ["b2b_no"],
        mergeIds: ["appointment_no"],
        tabName: "FBA",
      },
      modals: {
        saveWeight: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ id: row.id });
              this.$page
                .handleRequestMethods("saveWeight", data, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("体积重量"),
            modalBind: {
              width: 30,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              weight: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              square_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
            },
          },
          grid: [{ weight: 24 }, { square_number: 24 }],
          fields: [
            {
              name: this.$tz("重量"),
              key: "weight",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
            {
              name: this.$tz("体积"),
              key: "square_number",
              component: "InputNumber",
              default: 0,
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%",
              },
            },
          ],
        },
        batchEditTime: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("batchEditTime", row, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true,
              maskClosable: false,
            },
            rowBind: {
              gutter: 16,
            },
            title:
              this.$t("batch") + this.$t("modify") + this.$t("appointmentDate"),
            rules: {
              time: [{ required: true, trigger: "blur", type: "date" }],
            },
          },
          grid: [{ time: 24 }],
          fields: [
            {
              key: "time",
              name: () => this.$t("appointmentDate"),
              component: "DatePicker",
              placeholder: () => this.$t("select") + this.$t("appointmentDate"),
              bind: {
                type: "datetime",
                options: {
                  disabledDate(time) {
                    return time.getTime() < Date.now();
                  },
                },
              },
              methods: {
                format({ value }) {
                  return this.format.customTime(value);
                },
              },
            },
          ],
        },
        upload: {
          methods: {
            ok() {
              window.open(this.$globalUrl + this.params.file);
            },
          },
          footer: {
            cancel: {
              isShow: true,
            },
            ok: {
              name: this.$t("download_tem"),
            },
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true,
              maskClosable: false,
            },
            rowBind: {
              gutter: 16,
              // style: {
              //   marginBottom: "20px"
              // }
            },
            title: this.$t("upload") + this.$t("files"),
          },
          grid: [{ files: 24 }],
          fields: [
            {
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".xlsx",
              },
              methods: {
                beforeUpload: ({ file }) => {
                  let formData = new FormData();
                  formData.append("file", file); // 文件对象
                  let table = this.$refs["table"];
                  let modal = table.getModal("upload");
                  formData.append("type", modal.params.type);
                  table
                    .handleRequestMethods("addFile", formData, true, true)
                    .then((res) => {
                      table.getList();
                      _this.getModal("upload").close();
                    });
                  return false;
                },
              },
            },
          ],
        },
        excel: {
          methods: {
            ok({ row, close }) {
              this.$page.openLoading();
              if (!src.length)
                return this.$Message["error"]({
                  background: true,
                  content: this.$t("upload"),
                });
              this.$page
                .handleRequestMethods(
                  "src",
                  {
                    src: row.src,
                    task: row.task,
                  },
                  true,
                  true
                )
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                })
                .catch(() => {});
            },
          },
          footer: {
            show() {
              return this.type !== "read";
            },
            ok: {
              name: this.$t("Confirm Upload file"),
            },
          },
          config: {
            title: this.$t("Excel Import"),
            modalBind: {
              width: 1200,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
              styles: {
                top: "30px",
              },
            },
          },
          table: {
            config: {
              height: 600,
              resize: false,
            },
            header: {
              btns: {
                list: [
                  {
                    name: () => this.$t("Upload File"),
                    type: "1",
                    fnName: "updateFile",
                    component: "Upload",
                    bind: {
                      showUploadList: true,
                      icon: "ios-cloud-upload",
                      type: "warning",
                    },
                  },
                ],
                methods: {
                  updateFile({ file, searchForm, field }) {
                    let formData = new FormData();
                    formData.append("file", file);
                    this.$page
                      .handleRequestMethods("upload", formData, true, true)
                      .then((res) => {
                        this.$page
                          .getModal("excel")
                          .params.src.push(res.payload);
                      });
                    return false;
                  },
                },
              },
            },
            fields: [
              {
                name: () => this.$t("Tracking number"),
                key: "airway_number",
                minWidth: 150,
              },
              {
                name: () => this.$t("FBA Number"),
                key: "fba",
                minWidth: 150,
              },
              {
                name: "SKU",
                key: "sku",
                minWidth: 150,
              },
            ],
          },
        },
        add: {
          footer: {
            show() {
              return this.type !== "read";
            },
          },
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              console.log(data);
              if (data.boxes_number)
                data.boxes_number = data.boxes_number.join(",");
              if (data.change_boxes_number)
                data.change_boxes_number = data.change_boxes_number.join(",");
              this.$page.openLoading();
              this.$page
                .handleRequestMethods(this.type, data, true, true)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                })
                .catch(() => {});
            },
            cancel() {
              console.log(this);
              this.fields.forEach((t) => {
                if (["boxes_number", "change_boxes_number"].includes(t.key)) {
                  t.options = [];
                }
              });
            },
          },
          config: {
            modalBind: {
              width: 1000,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
              styles: {
                top: "30px",
              },
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
            },
            colBind: {
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              b2b_no: [{ required: true, trigger: "blur" }],
              store_name: [{ required: false, trigger: "blur" }],
              delivery_type: [{ required: true, trigger: "blur" }],
              shipment_no: [{ required: true, trigger: "blur" }],
              delivery_address: [{ required: true, trigger: "blur" }],
              delivery_time: [
                { required: true, trigger: "blur", type: "date" },
              ],
              number: [{ required: true, trigger: "blur", type: "number" }],
              delivery_method: [
                { required: true, trigger: "blur", type: "number" },
              ],
              boxes_number: [
                { required: true, trigger: "blur", type: "array" },
              ],
            },
          },
          grid: [
            {
              delivery_type: 12,
              appointment_no: 12,
              b2b_no: 12,
              store_name: 12,
              shipment_no: 12,
              tracking_number: 12,
              number: 12,
              total_pcs: 12,
              warehouse: 12,
              delivery_time: 12,
              delivery_method: 12,
              boxes_number: 12,
              delivery_address: 12,
              remarks: 12,
            },
            // {
            // 	group:true,
            // 	name:this.$t('Change')+this.$t('CargoLabel'),
            // 	children:[
            // 		{ change_boxes_number: 12, change_label_file:12, },
            // 	]
            // },
            // {
            // 	group:true,
            // 	name:this.$t('Change')+this.$t('SkuLabel'),
            // 	children:[
            // 		{change_sku_label_file:12},
            // 		{ change_sku_label: 24 },
            // 	]
            // }
          ],
          fields: [
            {
              name: () => this.$t("DeliveryMethod"),
              key: "delivery_method",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("DeliveryMethod");
              },
              clearable: false,
              options: [
                { label: this.$t("all"), value: 1 },
                { label: this.$t("Part"), value: 2 },
              ],
            },
            {
              name: () => this.$t("Delivery") + this.$t("type"),
              key: "delivery_type",
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") + this.$t("Delivery") + this.$t("type")
                );
              },
              options: deliveryOptions,
              methods: {
                "on-change": ({ fields, value, formData }) => {
                  if (value === "FBN") {
                    this.modals.add.config.rules.store_name[0].required = false;
                  } else {
                    this.modals.add.config.rules.store_name[0].required = true;
                  }
                  this.$forceUpdate();
                  fields.map((field) => {
                    if (field.key === "warehouse") {
                      field.options = this.warehouse.filter((t) => {
                        if (!value) return true;
                        return t.service_code === value;
                      });
                    }
                  });
                },
              },
            },
            {
              name: () => this.$t("noofpieces"),
              key: "total_pcs",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("noofpieces");
              },
            },
            {
              name: () => this.$t("appointmentNumber"),
              key: "appointment_no",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("appointmentNumber");
              },
            },
            {
              name: () => this.$t("Tracking number"),
              key: "b2b_no",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Tracking number");
              },
            },
            {
              name: () => this.$t("shop_name"),
              key: "store_name",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("shop_name");
              },
            },
            {
              name: () => this.$t("cargoNumber"),
              key: "shipment_no",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("cargoNumber");
              },
            },
            {
              name: () => this.$t("trackingNumber"),
              key: "tracking_number",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("trackingNumber");
              },
            },
            {
              name: () => this.$t("deliveryAddress"),
              key: "delivery_address",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("deliveryAddress");
              },
              bind: {
                type: "textarea",
                rows: 2,
              },
            },
            {
              name: () => this.$t("warehouse"),
              key: "warehouse",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("warehouse");
              },
              options: [],
              config: {
                label: "warehouse_name",
                value: "warehouse_name",
              },
              methods: {
                "on-change"({ field, formData }) {
                  field.options.forEach((t) => {
                    if (t.warehouse_name === formData.warehouse) {
                      formData.delivery_address = t.detailed_address;
                    }
                  });
                },
                list: ({ field }) => {
                  console.log(this);
                  field.options = this.warehouse;
                },
              },
            },
            {
              name: () => this.$t("Delivery") + this.$t("time"),
              key: "delivery_time",
              placeholder() {
                return (
                  this.$t("select") + this.$t("Delivery") + this.$t("time")
                );
              },
              component: "DatePicker",
              disabledDate: true,
              bind: {
                type: "datetime",
                clearable: false,
              },
            },
            {
              name: () => this.$t("CTNS"),
              key: "number",
              component: "InputNumber",
              bind: {
                style: "width:100%",
              },
              placeholder() {
                return this.$t("enter") + this.$t("CTNS");
              },
            },
            {
              name: () => this.$t("include") + this.$t("packingNum"),
              key: "boxes_number",
              component: "Select",
              bind: {
                "allow-create": true,
                multiple: true,
              },
              placeholder() {
                return (
                  this.$t("select") + this.$t("include") + this.$t("packingNum")
                );
              },
              show({ formData }) {
                return formData.delivery_method != 1;
              },
              options: [],
              default: [],
            },
            {
              name: () => this.$t("include") + this.$t("packingNum"),
              key: "change_boxes_number",
              component: "Select",
              bind: {
                "allow-create": true,
                multiple: true,
              },
              placeholder() {
                return (
                  this.$t("select") + this.$t("include") + this.$t("packingNum")
                );
              },
              options: [],
              default: [],
            },
            {
              name: () => this.$t("CargoLabel") + this.$t("PDFFile"),
              key: "change_label_file",
              component: "Upload",
              bind: {
                isButton: true,
                fileName: "changeFile",
                multiple: false,
              },
              methods: {
                beforeUpload: ({ file }) => {
                  let formData = new FormData();
                  formData.append("file", file);
                  uploadFile(formData).then((res) => {
                    console.log(res);
                    this.$refs["table"].getModal("add").setFormData({
                      change_label_file: {
                        src: res.data.payload,
                        name: file.name,
                      },
                    });
                  });
                  return false;
                },
              },
            },
            {
              name: () => this.$t("include") + this.$t("packingNum"),
              key: "change_sku_label",
              render: (h, p) => {
                if (!p.row.change_sku_label)
                  p.row.change_sku_label = [
                    {
                      boxes_number: "",
                      sku_number: "",
                    },
                  ];
                return h(Sku, {
                  attrs: {
                    list: p.row.change_sku_label,
                  },
                });
              },
            },
            {
              name: () => this.$t("SkuLabel") + this.$t("PDFFile"),
              key: "change_sku_label_file",
              component: "Upload",
              bind: {
                isButton: true,
                fileName: "changeFile",
                multiple: false,
              },
              methods: {
                beforeUpload: ({ file }) => {
                  let formData = new FormData();
                  formData.append("file", file);
                  uploadFile(formData).then((res) => {
                    console.log(res);
                    this.$refs["table"].getModal("add").setFormData({
                      change_sku_label_file: {
                        src: res.data.payload,
                        name: file.name,
                      },
                    });
                  });
                  return false;
                },
              },
            },
            {
              key: "remarks",
              name: () => this.$t("Remarks"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
              bind: {
                type: "textarea",
                rows: 2,
              },
            },
            // {
            //   name: () => this.$t("sort"),
            //   key: "sort",
            //   component: "InputNumber",
            //   placeholder() {
            //     return this.$t("enter") + this.$t("sort");
            //   },
            //   bind: {
            //     step: 1,
            //     min: 0,
            //     style: {
            //       width: "100%",
            //     },
            //   },
            //   default: 0,
            // },
          ],
        },
        uploadList: {
          footer: {
            show: () => false,
          },
          config: {
            width: 80,
          },
          table: {
            config: {
              height: 600,
            },
            fields: [],
          },
        },
        fileList: {
          methods: {
            ok({ row, close }) {
              console.log(row, this);
              row.src = this.list.map((t) => t.src);
              this.$page
                .handleRequestMethods("addFiles", row, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            width: 600,
          },
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                name: this.$t("file_name"),
                key: "name",
                minWidth: 100,
              },
              {
                name: this.$t("CurrentState"),
                key: "status",
                minWidth: 100,
              },
            ],
          },
        },
        match: {
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              data.orders = data.orders.split("\n");
              this.$page
                .handleRequestMethods("matchOrder", data, true)
                .then((res) => {
                  console.log(this);
                  this.getList();
                  close();
                });
            },
          },
          config: {
            rules: {
              orders: [
                {
                  required: true,
                  message: "orders be empty",
                  trigger: "bulr",
                },
              ],
              client_id: [
                {
                  required: true,
                  message: "orders be empty",
                  trigger: "bulr",
                  type: "number",
                },
              ],
            },
            formBind: {
              labelWidth: 110,
            },
            title: this.$t("Match old system order"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [{ client_id: 24 }, { orders: 24 }],
          fields: [
            {
              key: "orders",
              name: () => this.$t("Old system order"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Old system order");
              },
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
            {
              name: () => this.$t("clientName"),
              key: "client_id",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("clientName");
              },
              config: {
                value: "id",
                label: "account",
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getAllClient")
                  ).payload.rows;
                  this.$forceUpdate();
                },
              },
            },
          ],
        },
      },
      header: {
        config: {
          searchLength: 15,
        },
        searchs: [
          // {
          //   key: "appointment_no",
          //   placeholder() {
          //     return this.$t("appointmentNumber");
          //   },
          //   component: "Input",
          // },
          // {
          //   key: "b2b_no",
          //   placeholder() {
          //     return this.$t("Tracking number");
          //   },
          //   component: "Input",
          // },
          {
            key: "customer_service_id",
            component: "Select",
            bind: {
              style: "width:150px",
            },
            placeholder() {
              return this.$t("select") + this.$t("serviceAccount");
            },
            options: [],
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id",
            },
          },
          {
            key: "delivery_status",
            placeholder() {
              return (
                this.$t("select") + this.$t("Delivery") + this.$t("exlType")
              );
            },
            component: "Select",
            options: [],
            default: 0,
          },
          {
            key: "delivery_type",
            placeholder() {
              return this.$t("select") + this.$t("Delivery") + this.$t("type");
            },
            component: "Select",
            options: deliveryOptions,
          },
          {
            key: "service_type",
            placeholder() {
              return this.$t("select") + this.$t("serviceType");
            },
            component: "Select",
            options: [],
            methods: {
              list({ field }) {
                this.$page.handleRequestMethods("getService").then((res) => {
                  field.options = res.payload;
                });
              },
            },
          },
          {
            key: "dateType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            component: "Select",
            options: [],
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              style: {
                width: "175px",
              },
            },
            disabledDate: true,
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              },
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            disabledDate: true,
            bind: {
              type: "datetime",
              style: {
                width: "175px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              },
            },
          },
          // {
          //   key: "is_swap",
          //   placeholder() {
          //     return this.$t("select") + this.$t("LabelsNeedReplaced");
          //   },
          //   component: "Select",
          //   options: [
          //   	{label:this.$t('YES'),value:1},
          //   	{label:this.$t('NO'),value:0}
          //   ],
          // },
          // {
          //   key: "swap_finish",
          //   placeholder() {
          //     return this.$t("select") + this.$t("labelIsReplaced");
          //   },
          //   component: "Select",
          //   options: [
          // 		{label:this.$t('YES'),value:1},
          // 		{label:this.$t('NO'),value:0}
          // 	],
          // },
          {
            key: "charge_status",
            placeholder() {
              return this.$tz("是否录入重量信息");
            },
            component: "Select",
            options: [
              { label: this.$t("YES"), value: 1 },
              { label: this.$t("NO"), value: 2 },
            ],
          },
          {
            key: "country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("target_country");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            bind: {
              style: "width:150px",
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 2,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning",
              },
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
              disabled() {
                return this.config.tabName === "FBA"
                  ? false
                  : !this.selectAll.length;
              },
            },
            // {
            // 	name: () => this.$t("import"),
            // 	type: 'upload',
            // 	fnName: 'upload',
            // 	component:'Upload',
            // 	bind:{
            // 		type:'primary',
            // 		showUploadList:false,
            // 	}
            // },
            // {
            // 	name: () => this.$t("import")+this.$t('template'),
            // 	type: 'down',
            // 	fnName: 'down',
            // 	bind:{
            // 		type:'primary',
            // 	}
            // },
            {
              name: () => this.$t("updateFile") + "FBA",
              type: "1",
              fnName: "uploadModal",
              src: "/doc/zh-CN/FBA.xlsx",
              bind: {
                type: "warning",
              },
            },
            {
              name: () => this.$t("updateFile") + "FBN",
              type: "4",
              fnName: "uploadModal",
              src: "/doc/zh-CN/FBN.xlsx",
              bind: {
                type: "warning",
              },
            },
            {
              name: () => this.$t("updateFile") + "FBT",
              type: "5",
              fnName: "uploadModal",
              src: "/doc/zh-CN/FBT.xlsx",
              bind: {
                type: "warning",
              },
            },
            {
              name: () => this.$t("updateFile") + "FBJ",
              type: "6",
              fnName: "uploadModal",
              src: "/doc/zh-CN/FBJ.xlsx",
              bind: {
                type: "warning",
              },
            },
            {
              name: () =>
                this.$t("updateFile") +
                this.$t("appointmentNumber") +
                this.$t("Appendix"),
              type: "2",
              fnName: "updateFile",
              bind: {
                icon: "ios-cloud-upload",
                type: "warning",
              },
            },
            {
              name: () => this.$t("specialSign") + this.$t("updateFile"),
              type: "3",
              fnName: "updateFile",
              show: () => this.tabName === "FBA",
              bind: {
                icon: "ios-cloud-upload",
                type: "warning",
              },
            },
            {
              name: () => this.$t("signDownload"),
              type: "exportFun",
              fnName: "exportFun",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: () => this.$t("ReceiptSignReceiptDownload"),
              type: "exportFun1",
              fnName: "exportFun",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: () => this.$t("Match old system order"),
              type: "match",
              fnName: "match",
              bind: {
                type: "primary",
              },
            },
            {
              name: () => this.$t("batch") + this.$t("delete"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error",
              },
              id: 1481,
              disabled() {
                return !this.selectAll.length;
              },
            },
            {
              name: () =>
                this.$t("batch") +
                this.$t("modify") +
                this.$t("appointmentDate"),
              type: "batchEditTime",
              fnName: "batchEditTime",
              bind: {
                type: "success",
              },
              id: 1616,
              disabled() {
                return !this.selectAll.length;
              },
            },
            // {
            // 	name: () => this.$tz("体积重量"),
            // 	type: "saveWeight",
            // 	fnName: "saveWeight",
            // 	bind: {
            // 		type: "success"
            // 	},
            // 	id: 1616,
            // 	disabled() {
            // 		return !this.selectAll.length;
            // 	},
            // },
          ],
          methods: {
            saveWeight() {
              this.getModal("saveWeight").open({
                param: this.selectAll.map((item) => ({
                  appointment_no:
                    this.config.tabName == "FBA"
                      ? item.appointment_no
                      : item.shipment_no,
                  b2b_no: item.b2b_no,
                })),
                type: this.config.tabName,
              });
            },
            batchEditTime() {
              this.getModal("batchEditTime").open({
                param: this.selectAll.map((item) => ({
                  appointment_no:
                    this.config.tabName == "FBA"
                      ? item.appointment_no
                      : item.shipment_no,
                  b2b_no: item.b2b_no,
                })),
                type: this.config.tabName,
                time: "",
              });
            },
            delete({ field }) {
              this.$Modal.confirm({
                title: this.$t("batch") + this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  let data = {
                    delete: this.selectAll.map((item) => ({
                      appointment_no: item.appointment_no,
                      b2b_no: item.b2b_no,
                    })),
                  };
                  this.handleRequestMethods("batchDel", data, true, true).then(
                    (res) => {
                      this.getList();
                    }
                  );
                },
              });
            },
            match({ field }) {
              this.getModal("match").open();
            },
            uploadModal({ field }) {
              this.getModal("upload").open({
                file: field.src,
                type: field.type,
              });
            },
            ExcelImport({ file }) {
              let formData = new FormData();
              formData.append("file", file);
              this.$page
                .handleRequestMethods("excel", formData, true, true)
                .then((res) => {
                  res.payload.src = [];
                  this.$page.getModal("excel").open(res.payload, function () {
                    this.list = res.payload.rows;
                  });
                });
              return false;
            },
            exportFun({ searchForm, field }) {
              let data = {
                export: this.selectAll.map((item) => ({
                  appointment_no:
                    this.config.tabName == "FBA"
                      ? item.appointment_no
                      : item.shipment_no,
                  b2b_no: item.b2b_no,
                  type: this.config.tabName,
                })),
              };
              this.openLoading();
              this.handleRequestMethods(field.type, data, true, true).then(
                (res) => {
                  window.open(this.$globalUrl + res.payload.src);
                }
              );
            },
            updateFile({ field }) {
              let el = document.createElement("input");
              let extend = [];
              let length = 0;
              el.type = "file";
              el.multiple = true;
              el.click();
              el.addEventListener("input", (e) => {
                // let formData = new FormData();
                // Object.values(el.files).forEach(file=>{
                // 	console.log(file);
                // 	formData.append("files[]", file);
                // })

                // formData.append("type", field.type);
                // this
                //   .handleRequestMethods("addFiles", formData, true, true)
                //   .then(res => {
                //     this.getList();
                //   });

                this.getModal("fileList").open(
                  { type: field.type },
                  function () {
                    let list = Object.values(el.files).map((t) => {
                      let item = {
                        status: this.$t("uploading"),
                        src: "",
                        name: t.name,
                      };
                      this.setTitle(field.name());
                      let formData = new FormData();
                      formData.append("file", t);
                      formData.append("type", "FBA");
                      this.$page
                        .handleRequestMethods("CommonUpload", formData)
                        .then((res) => {
                          item.src = res.payload;
                          item.status = this.$t("success");
                        })
                        .catch((err) => {
                          item.status = this.$t("uploadFail");
                        });
                      return item;
                    });
                    console.log(list);
                    this.list = list;
                  }
                );
              });
              // let formData = new FormData();
              // formData.append("files", file);
              // formData.append("type", field.type);
              // this.$page
              //   .handleRequestMethods("addFile", formData, true, true)
              //   .then(res => {
              //     this.$page.getList();
              //   });
            },
            down() {
              window.open(
                this.$globalUrl +
                  "/static/templates/UploadDeliveryServer.xlsx".replace(
                    "lang",
                    this.$i18n.locale
                  )
              );
            },
            export({ searchForm }) {
              this.config.tabName === "FBA"
                ? this.handleRequestMethods("list", {
                    ...searchForm,
                    export: 1,
                  }).then(
                    (res) => {
                      console.log(res);
                      window.open(this.$globalUrl + res.payload.src);
                    },
                    true,
                    true
                  )
                : this.exportExc();
            },
            upload({ file }) {
              this.$page
                .readFile(file)
                .then((res) => {
                  console.log(res);
                  let headers = Object.keys(res[0]);

                  let keys = Object.values(res.splice(0, 1)[0]);
                  let values = res;
                  let headersKeys = {};
                  headers.forEach((t, i) => {
                    headersKeys[t] = keys[i];
                  });
                  let data = values.map((t) => {
                    console.log(t);
                    let obj = {};
                    headers.map((k, i) => {
                      if (headersKeys[k] === "delivery_time") {
                        obj[headersKeys[k]] = t[k]
                          ? this.$page.format.timeFormat(t[k])
                          : "";
                      } else obj[headersKeys[k]] = t[k];
                    });
                    return obj;
                  });
                  console.log(data);
                  // this.openLoading()
                  this.$page.modals.uploadList.table.fields = headers.map(
                    (t, i) => {
                      return {
                        key: keys[i],
                        name: t,
                        minWidth: i === 0 ? 160 : 120,
                        bind: {
                          style({ row }) {
                            return row.error ? { color: "red" } : {};
                          },
                        },
                      };
                    }
                  );
                  // return this.$page.handleRequestMethods('add',t)
                  let list = [];
                  let batchAdd = () => {
                    this.$page.openLoading();
                    if (!data.length) {
                      this.$page.getModal("uploadList").open({}, function () {
                        this.setTitle(this.$t("uploadRes"));
                        this.list = list;
                      });
                      this.$page.getList();
                      return this.$page.closeLoading();
                    }
                    add(data[0]).then((res) => {
                      if (res.data.status) {
                        list.push(data[0]);
                      } else {
                        list.push({
                          [keys[0]]: res.data.msg,
                          error: 1,
                        });
                        console.log({
                          [keys[0]]: res.data.msg,
                          error: 1,
                        });
                      }
                      data.splice(0, 1);
                      batchAdd();
                    });
                  };
                  batchAdd();
                  /* let keys = ['date',	'client',	'warehouse',	'quantity',	'volume_weight']
								let data = res.map(item=>{
									return Object.values(item).reduce((a,b,i)=>{
										a[keys[i]] = b
										return a
									},{})
								}) */
                  // this.$page.handleRequestMethods('uploadFixedStock',{data},true,true).then(res=>{
                  // 	this.$page.getList();
                  // })
                })
                .catch((err) => {
                  console.log(err);
                });
              return false;
            },
            add() {
              this.getModal("add").open(null, function () {
                this.setTitle(this.$t("add"));
                this.type = "add";
                this.config.formBind.disabled = false;
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("serviceType"),
          key: "service_type",
          minWidth: 150,
          show: () => this.tabName === "FBA",
        },
        {
          name: () => this.$t("Delivery") + this.$t("type"),
          key: "delivery_type",
          minWidth: 150,
        },
        {
          name: () =>
            this.tabName === "FBA" || this.tabName === 'FBT'
              ? this.$t("appointmentNumber")
              : this.$t("order_refCode"),
          key: "appointment_no",
          fixed: "left",
          minWidth: 150,
          copy: true,
          header: {
            copy: true,
          },
        },
        {
          name: () => this.$t("order_number"),
          key: "b2b_no",
          minWidth: 150,
          fixed: "left",
          copy: true,
          header: {
            copy: true,
          },
        },
        {
          name: () => this.$t("Company name"),
          key: "company",
          minWidth: 150,
          fixed: "left",
        },
        {
          name: () => this.$t("agentT"),
          key: "agent",
          minWidth: 150,
          show: () => this.tabName === "FBN",
        },

        {
          name: () => this.tabName + this.$t("cargoNumber"),
          key: "shipment_no",
          minWidth: 150,
          show: () => this.tabName === "FBN",
        },

        {
          name: () => this.$t("deliveryWarehouse"),
          key: "warehouse",
          rewriteKey: "warehouse1",
          minWidth: 150,
          show: () => this.tabName === "FBA" || this.tabName === 'FBT',
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          minWidth: 150,
          show: () => this.tabName === "FBA",
        },

        {
          name: () => "FBN" + this.$t("warehouse"),
          key: "warehouse",
          minWidth: 150,
          show: () => this.tabName === "FBN",
        },
        {
          name: () => this.$t("Delivery warehouse"),
          key: "warehouseTitle",
          minWidth: 150,
          show: () => this.tabName === "FBN",
        },
        {
          name: () => "B2B " + this.$t("batch_number"),
          key: "b2b_no_batch",
          minWidth: 150,
          show: () => this.tabName === "FBA",
        },

        {
          name: () => this.tabName + this.$t("cargoNumber"),
          key: "shipment_no",
          rewriteKey: "shipment_no1",
          minWidth: 150,
          child: { list: "child", child: { list: "child" } },
          type: "child",
          show: () => this.tabName === "FBA",
        },
        {
          name: () => this.$t("trackingNumber"),
          key: "tracking_number",
          minWidth: 150,
          show: () => this.tabName === "FBA",
          type: "child",
          child: { list: "child", child: { list: "child" } },
        },
        {
          name: () => this.$t("CTNS"),
          key: "number",
          rewriteKey: "number1",
          minWidth: 150,
          child: { list: "child", child: { list: "child" } },
          type: "child",
          show: () => this.tabName === "FBA",
        },

        {
          name: () => this.$t("noofpieces"),
          key: "total_pcs",
          rewriteKey: "total_pcs1",
          minWidth: 150,
          child: { list: "child", child: { list: "child" } },
          type: "child",
          show: () => this.tabName === "FBA",
        },

        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          rewriteKey: "remarks1",
          minWidth: 150,
          child: { list: "child", child: { list: "child" } },
          type: "child",
          show: () => this.tabName === "FBA",
        },
        {
          name: () =>
            this.tabName === "FBA"
              ? this.$t("shop_name")
              : this.$t("clientName"),
          key: "store_name",
          minWidth: 150,
        },

        // {
        //   name: () => this.$t("LabelsNeedReplaced"),
        //   key: "is_swap",
        //   minWidth: 150,

        // },
        // {
        //   name: () => this.$t("labelIsReplaced"),
        //   key: "swap_finish",
        //   minWidth: 150,

        // },
        {
          name: () => this.$t("serviceAccount"),
          key: "serviceName",
          minWidth: 150,
        },

        // {
        //   name: () => this.$t("downloadReceipt"),
        //   key: "b2b_no",
        // 	rewriteKey:"b2b_no1",
        //   minWidth: 150,
        // 	component:'Button',
        // 	fixed:'right',
        // 	bind: {
        // 	  type: "success",
        // 	  size: "small",
        // 	},
        // 	disabled({row}){
        // 		return !row['sign_src']
        // 	},
        // 	methods:{
        // 		click({row}){
        // 			window.open(
        // 			  (row.sign_src.search(/.(xls|xlsx)/) !== -1?this.$prviewUrl:'') + this.$globalUrl + row.sign_src
        // 			);
        // 		},
        // 		render(){
        // 			return this.$t('download')
        // 		}
        // 	},
        // 	show:()=>this.tabName === 'FBA'
        // },
        // {
        //   name: () => this.$t("downloadEnclosure"),
        //   key: "enclosure",
        //   minWidth: 150,
        // 	component:'Button',
        // 	bind: {
        // 	  type: "success",
        // 	  size: "small",
        // 	},
        // 	disabled({row}){
        // 		return !row['enclosure']
        // 	},
        // 	fixed:'right',
        // 	methods:{
        // 		click({row}){
        // 			window.open(this.$globalUrl+row['enclosure'])
        // 		},
        // 		render(){
        // 			return this.$t('download')
        // 		}
        // 	},
        // 	show:()=>this.tabName === 'FBA'
        // },
        {
          name: () => this.$t("rejection_boxno"),
          key: "rejection_boxno",
          minWidth: 150,
        },
        {
          name: () => this.$t("Delivery") + this.$t("exlType"),
          key: "delivery_status",
          minWidth: 150,
          fixed: "right",
        },

        {
          name: () => this.$t("ReceiptSignReceipt"),
          key: "receipt_sign",
          minWidth: 150,
          component: "Button",
          bind: {
            type: "success",
            size: "small",
          },
          disabled({ row }) {
            return !row["receipt_sign"];
          },
          methods: {
            click({ row }) {
              window.open(row["receipt_sign"]);
            },
            render() {
              return this.$t("show");
            },
          },
          // show:()=>this.tabName === 'FBA'
        },

        {
          name: () => this.$t("WarehouseOutTime"),
          key: "warehouse_out_time",
          minWidth: 160,
          show: () => this.tabName === "FBA",
        },
        {
          name: () => this.$t("Delivery") + this.$t("time"),
          key: "delivery_time",
          minWidth: 160,
          // show:()=>this.tabName === 'FBA'
        },
        {
          name: () => this.$t("CTNS"),
          key: "number",
          minWidth: 150,
          show: () => this.tabName === "FBN",
        },
        {
          name: () => this.$tz("PCS数"),
          key: "total_pcs",
          minWidth: 150,
          show: () => this.tabName === "FBN",
        },
        {
          name: () => this.$t("allow_depart"),
          key: "from_country",
          minWidth: 150,
          show: () => this.tabName === "FBA",
        },
        {
          name: () => this.$t("allow_arrive"),
          key: "to_country",
          minWidth: 150,
          show: () => this.tabName === "FBA",
        },
        {
          name: () => this.$t("invoiceWeight"),
          key: "weight",
          minWidth: 150,
        },
        {
          name: () => this.$t("square"),
          key: "square_number",
          minWidth: 150,
        },
        {
          name: () => this.$t("deliveryAddress"),
          key: "delivery_address",
          minWidth: 150,
        },
        {
          name: () => this.$t("DeliveryFailReason"),
          key: "receipt_remarks",
          minWidth: 150,
        },

        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          minWidth: 150,
          show: () => this.tabName === "FBN",
        },
        {
          width: 100,
          name: () => this.$t("operation"),
          fixed: "right",
          key: "operation",
          type: "btns",
          show: () => this.tabName === "FBA",
          noAutoWidth: true,
          list: [
            {
              name: () => this.$t("downloadReceipt"),
              type: "preview",
              fnName: "previewFun",
              disabled: ({ row }) => !row.sign_src,
              bind: {
                type({ row }) {
                  return row.is_special == 1 ? "success" : "primary";
                },
              },
            },
            {
              name: () => this.$t("downloadEnclosure"),
              type: "enclosure",
              fnName: "enclosure",
              disabled: ({ row }) => !row.enclosure,
              bind: {
                type: "primary",
              },
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error",
              },
              show: () => this.tabName === "FBA",
            },
          ],

          methods: {
            enclosure({ row }) {
              window.open(row.enclosure);
            },
            previewFun({ row }) {
              // console.log(this.$prviewUrl + row.sign_src);
              window.open(row.sign_src);
              // let that = this;
              // this.$Spin.show()
              // signProof(row.b2b_no).then(res => {
              //   this.$Spin.hide()
              //   let LODOP = getLodop(that);
              //   LODOP.PRINT_INIT("打印任务名"); //首先一个初始化语句
              //   LODOP.SET_PRINT_PAGESIZE(1, "210mm", "297mm", ""); //规定纸张大小；使用A4纸
              //   LODOP.ADD_PRINT_PDF(0, 0, "100%", "100%", res.data.payload);
              //   LODOP.PREVIEW()
              // }).catch(e => {
              //   this.$Spin.hide()
              //   this.$Message.error(e.message)
              // })
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("Del", {
                    appointment_no: row.appointment_no,
                    b2b_no: row.b2b_no,
                  }).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
        {
          width: () => {
            console.log(this);
            return this.$i18n.locale === "zh-CN" ? 200 : 300;
          },
          name: () => this.$t("operation"),
          fixed: "right",
          key: "operation",
          rewriteKey: "operation3",
          type: "child",
          show: () => this.tabName === "FBA",
          child: { list: "child", child: { list: "child" }, btns: true },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
            },
            {
              name: this.$t("showDetail"),
              type: "show",
              fnName: "show",
            },
            // {
            // 	name: () => this.$t("downloadReceipt"),
            // 	type: "preview",
            // 	fnName: "previewFun",
            // 	disabled:({row})=>!row.sign_src,
            // 	bind: {
            // 		type: "primary"
            // 	}
            // },
            // {
            // 	name: () => this.$t("downloadEnclosure"),
            // 	type: "enclosure",
            // 	fnName: "enclosure",
            // 	disabled:({row})=>!row.enclosure,
            // 	bind: {
            // 		type: "primary"
            // 	}
            // },
          ],

          methods: {
            enclosure({ row }) {
              window.open(row.enclosure);
            },
            previewFun({ row }) {
              console.log(this.$prviewUrl + row.sign_src);
              window.open(row.sign_src);
            },
            show({ row }) {
              this.handleRequestMethods("getDetails", row.id).then((res) => {
                if (res.payload.change_label_file)
                  res.payload.change_label_file = {
                    src: res.payload.change_label_file,
                    preview: true,
                    name: this.$t("CargoLabel") + this.$t("PDFFile"),
                  };
                if (res.payload.change_sku_label_file)
                  res.payload.change_sku_label_file = {
                    src: res.payload.change_sku_label_file,
                    preview: true,
                    name: this.$t("SkuLabel") + this.$t("PDFFile"),
                  };
                this.modals.add.fields.forEach((t) => {
                  if (
                    ["boxes_number", "change_boxes_number"].includes(t.key) &&
                    res.payload[t.key]
                  ) {
                    t.options = res.payload[t.key].split(",").map((t) => ({
                      label: t,
                      value: t,
                    }));
                    res.payload[t.key] = res.payload[t.key].split(",");
                  }
                });
                this.getModal("add").setTitle(this.$t("showDetail"));
                this.getModal("add").type = "read";
                this.getModal("add").open(res.payload, function () {
                  this.config.formBind.disabled = true;
                });
              });
            },
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then((res) => {
                if (res.payload.change_label_file)
                  res.payload.change_label_file = {
                    src: res.payload.change_label_file,
                    preview: true,
                    name: this.$t("CargoLabel") + this.$t("PDFFile"),
                  };
                if (res.payload.change_sku_label_file)
                  res.payload.change_sku_label_file = {
                    src: res.payload.change_sku_label_file,
                    preview: true,
                    name: this.$t("SkuLabel") + this.$t("PDFFile"),
                  };
                this.modals.add.fields.forEach((t) => {
                  if (
                    ["boxes_number", "change_boxes_number"].includes(t.key) &&
                    res.payload[t.key]
                  ) {
                    t.options = res.payload[t.key].split(",").map((t) => ({
                      label: t,
                      value: t,
                    }));
                    res.payload[t.key] = res.payload[t.key].split(",");
                  }
                });
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload, function () {
                  this.config.formBind.disabled = false;
                });
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("Del", row.id).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
        {
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          key: "operation1",
          type: "btns",
          show: () => this.tabName === "FBN",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              show: () => this.tabName === "FBN",
            },
            {
              name: this.$t("showDetail"),
              type: "show",
              fnName: "show",
              show: () => this.tabName === "FBN",
            },
            {
              name: () => this.$t("downloadReceipt"),
              type: "preview",
              fnName: "previewFun",
              disabled: ({ row }) => !row.sign_src,
              bind: {
                type: "primary",
              },
              show: () => this.tabName === "FBN",
            },
            {
              name: () => this.$t("downloadEnclosure"),
              type: "enclosure",
              fnName: "enclosure",
              disabled: ({ row }) => !row.enclosure,
              bind: {
                type: "primary",
              },
              show: () => this.tabName === "FBN",
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error",
              },
              show: () => this.tabName === "FBN",
            },
          ],

          methods: {
            enclosure({ row }) {
              window.open(row.enclosure);
            },
            previewFun({ row }) {
              console.log(this.$prviewUrl + row.sign_src);
              window.open(row.sign_src);
            },
            show({ row }) {
              this.handleRequestMethods("getDetails", row.id).then((res) => {
                if (res.payload.change_label_file)
                  res.payload.change_label_file = {
                    src: res.payload.change_label_file,
                    preview: true,
                    name: this.$t("CargoLabel") + this.$t("PDFFile"),
                  };
                if (res.payload.change_sku_label_file)
                  res.payload.change_sku_label_file = {
                    src: res.payload.change_sku_label_file,
                    preview: true,
                    name: this.$t("SkuLabel") + this.$t("PDFFile"),
                  };
                this.modals.add.fields.forEach((t) => {
                  if (
                    ["boxes_number", "change_boxes_number"].includes(t.key) &&
                    res.payload[t.key]
                  ) {
                    t.options = res.payload[t.key].split(",").map((t) => ({
                      label: t,
                      value: t,
                    }));
                    res.payload[t.key] = res.payload[t.key].split(",");
                  }
                });
                this.getModal("add").setTitle(this.$t("showDetail"));
                this.getModal("add").type = "read";
                this.getModal("add").open(res.payload, function () {
                  this.config.formBind.disabled = true;
                });
              });
            },
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then((res) => {
                if (res.payload.change_label_file)
                  res.payload.change_label_file = {
                    src: res.payload.change_label_file,
                    preview: true,
                    name: this.$t("CargoLabel") + this.$t("PDFFile"),
                  };
                if (res.payload.change_sku_label_file)
                  res.payload.change_sku_label_file = {
                    src: res.payload.change_sku_label_file,
                    preview: true,
                    name: this.$t("SkuLabel") + this.$t("PDFFile"),
                  };
                this.modals.add.fields.forEach((t) => {
                  if (
                    ["boxes_number", "change_boxes_number"].includes(t.key) &&
                    res.payload[t.key]
                  ) {
                    t.options = res.payload[t.key].split(",").map((t) => ({
                      label: t,
                      value: t,
                    }));
                    res.payload[t.key] = res.payload[t.key].split(",");
                  }
                });
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload, function () {
                  this.config.formBind.disabled = false;
                });
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("Del", {
                    appointment_no: row.shipment_no,
                    b2b_no: row.b2b_no,
                    type: "FBN",
                  }).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
  async mounted() {
    let res = await getSelectType([
      "WAREHOUSE_DELIVERY_STATUS",
      "WAREHOUSE_DATE_TYPE",
    ]);
    let client = (await getAllClient()).data.payload.rows;
    this.warehouse = (await getAddress()).data.payload;
    let data = (await getAllService()).data.payload;
    let service = (await getUser({ type: 1 })).data.payload[2];
    let country = (await getCountry()).data.payload.rows;
    this.header.searchs.forEach(async (item) => {
      if (item.key === "client_id") item.options = client;
      if (item.key === "customer_service_id") item.options = data[2];
      if (item.key === "delivery_status")
        item.options = res.data.payload["WAREHOUSE_DELIVERY_STATUS"];
      if (item.key === "dateType")
        item.options = res.data.payload["WAREHOUSE_DATE_TYPE"];
      if (item.key === "country") item.options = country;
    });
  },
};
</script>
